import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default function Message({ type, children }) {
  return <div className={`Message Message--${type}`}>{children}</div>;
}

Message.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Message.defaultProps = {
  type: 'info',
};
